import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IScorecardPreview } from '../../../../shared/models/scorecard-preview.model';
import { CircularProgressBarComponent } from '../../../../shared/components/circular-progress-bar/circular-progress-bar.component';
import { NgOptimizedImage } from '@angular/common';
import { ScorecardPercentagePipe } from '../../../../shared/pipes/scorecard-percentage.pipe';

@Component({
  selector: 'cv-scorecard-preview',
  standalone: true,
  imports: [CircularProgressBarComponent, NgOptimizedImage, ScorecardPercentagePipe],
  template: `
    <div class="scorecard-wrapper">
      <div class="progress-bar-wrapper">
        <cv-circular-progress-bar
          [value]="
            scorecard.disqualified
              ? 100
              : (scorecard.scoreAchieved | scorecardPercentage: scorecard.totalPossiblePoints)
          "
          [color]="scorecard.disqualified ? failColor : successColor"
        >
          <img ngSrc="assets/icons/user-headset.svg" priority alt="user headset icon" height="18" width="18" />
        </cv-circular-progress-bar>
      </div>

      <span>{{ scorecard.scorecardName }}:</span>
      @if (scorecard.disqualified) {
        <span>(Ineligible)</span>
      } @else {
        <span>
          {{ scorecard.scoreAchieved }}/{{ scorecard.totalPossiblePoints }} ({{
            scorecard.scoreAchieved | scorecardPercentage: scorecard.totalPossiblePoints
          }}%)
        </span>
      }
      <span class="pi pi-arrow-right"></span>
    </div>
  `,
  styleUrl: './scorecard-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScorecardPreviewComponent {
  @Input({ required: true }) scorecard!: IScorecardPreview;

  readonly successColor: string = '#56c059';
  readonly failColor: string = '#f13b44';
}
